export default __webpack_public_path__ + "static/media/tavi_main_small.41add0b1.jpg";